import { Box } from '@mui/system';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { ApiWorkflowDialog, TextField } from '@verantos-dev/shared-components';

import { useCopyCohortModal } from './hooks/useCopyCohortModal';

export const CopyCohortModal: FC = () => {
  const intl = useIntl();
  const {
    closeDialog,
    newCohortName,
    handleCohortNameChange,
    handleSubmit,
    isSubmitting,
    isValidForSubmit,
    submittingError,
  } = useCopyCohortModal();

  return (
    <ApiWorkflowDialog
      id="copyCohortModal"
      onClose={closeDialog}
      title={intl.formatMessage({ id: 'cohortsList.copyCohortModal.title' })}
      dialogMessages={{
        entrySaveButtonText: intl.formatMessage({ id: 'cohortsList.copyCohortModal.copyButton' }),
        entryCancelButtonText: intl.formatMessage({
          id: 'cohortsList.copyCohortModal.cancelButton',
        }),
        submittingSaveButtonText: intl.formatMessage({
          id: 'cohortsList.copyCohortModal.submitting',
        }),
        submittingErrorText: intl.formatMessage({
          id: 'cohortsList.copyCohortModal.submittingError',
        }),
        successCloseButtonText: intl.formatMessage({
          id: 'cohortsList.copyCohortModal.closeButton',
        }),
        successTitle: intl.formatMessage({ id: 'cohortsList.copyCohortModal.success.title' }),
      }}
      onSubmit={handleSubmit}
      isValidForSubmit={isValidForSubmit}
      isSubmitting={isSubmitting}
      submittingError={submittingError}
    >
      <Box
        sx={{
          marginTop: 2,
        }}
      >
        <TextField
          id="cohortName"
          displayLabel={intl.formatMessage({ id: 'cohortsList.copyCohortModal.cohortName.label' })}
          placeholder={intl.formatMessage({
            id: 'cohortsList.copyCohortModal.cohortName.placeholder',
          })}
          value={newCohortName}
          onChange={handleCohortNameChange}
          maxCharacters={60}
          maxCharacterErrorMsg={intl.formatMessage({
            id: 'cohortsList.copyCohortModal.cohortName.maxCharacterError',
          })}
          displayNumCharacter
          width="auto"
          beepMaxCharacters
        />
      </Box>
    </ApiWorkflowDialog>
  );
};
